import { isApproverEmail } from './approverStore';

// Users who manage support tickets instead of raising them: the current direct order approvers.
export const isTicketAdmin = (email) => isApproverEmail(email);
